import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Flex, Tag } from '@chakra-ui/react';
import { Moment } from 'moment';
import { getCalendarSlot } from '../utils/dateUtils';
import { updateAppointment } from '../../api/planningApi';
import DropElement from '../dragAndDrop/DropElement';
import { TState, useActions } from '../../redux/store';

const DropMinutes = ({ day, hour }: { day: Moment; hour: number }) => {
  const theme = useSelector((state: TState) => state.theme);

  const [dragHoverO, setDragHoverO] = useState(false);
  const [dragHover, setDragHover] = useState('');

  const { fetchAppointments } = useActions();

  return (
    <Flex
      w='100%'
      opacity={dragHoverO ? 1 : 0}
      onDragOver={() => setDragHoverO(true)}
      onDragLeave={() => setDragHoverO(false)}
    >
      {['00', '15', '30', '45'].map((min) => {
        const dateTime = getCalendarSlot(day, hour, Number(min)).toISOString();

        return (
          <DropElement
            noDrag={true}
            id={dateTime}
            onDrop={async (id: string, hour: string) => {
              setDragHoverO(false);
              setDragHover('');

              await updateAppointment(id, {
                planningDate: hour,
              });

              fetchAppointments();
            }}
            type='CALENDAR'
          >
            <Tag
              onDragOver={() => setDragHover(min)}
              onDragLeave={() => setDragHover('')}
              display='flex'
              flexGrow={1}
              mx={1}
              backgroundColor={dragHover === min ? theme.normal : theme.light}
            >
              {min}
            </Tag>
          </DropElement>
        );
      })}
    </Flex>
  );
};

export default DropMinutes;
